import { useEffect } from 'react';

import Assinatura from 'Interface/Assinaturas';
import { useRecuperarAssinaturasQuery } from 'Service';

import { useIdentity } from './Authentication';

export const useSubscription = (): Assinatura | null | false => {
  const identity = useIdentity();

  const { data, refetch, isLoading } = useRecuperarAssinaturasQuery(undefined, {
    skip: !identity,
  });

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(refetch, []);

  if (isLoading) {
    return null;
  }

  return data?.assinaturas && data.assinaturas.length
    ? data.assinaturas[0]
    : false;
};
